/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_exponential_histogram.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts histogram-like values to an exponential histogram.',
  examples: [
    'FROM histogram_standard_index\n | WHERE STARTS_WITH(instance, "hand-rolled")\n | EVAL converted = to_exponential_histogram(responseTime)\n | SORT instance\n | KEEP responseTime, converted\n;',
  ],
  params: {
    field: 'The histogram value to be converted',
  },
};

export default docs;
